/* eslint-disable max-len */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";
import { CognitoData } from "../../../CommonMethods/CognitoData";
import { createSelector } from '@reduxjs/toolkit';

const initialState = {
    loading: true,
    error: '',
    success: '',
    List:[]
}
export const StudentsAttendance = createAsyncThunk('Attendance', async (searchParams) => {
    
    let res = await dataService.GetAPI(searchParams);
    //let res = await dataService.GetAPI(searchParams.toString());
    return res
})
const StudentsAttendanceSlice = createSlice({

    name: 'Students-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [StudentsAttendance.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [
            
        StudentsAttendance.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [StudentsAttendance.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})


export const { setLoading } = StudentsAttendanceSlice.actions;
export default StudentsAttendanceSlice.reducer
export const attendanceSliceData=(state)=>state.StudentsAttendanceSlice.loading
export const selectStudentsList = (state) => state.StudentsAttendanceSlice.List
